import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { FaArrowRight, FaCheck, FaTwitter, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const PricingPage = () => {
  const navigate = useNavigate();
  const [billingPeriod, setBillingPeriod] = useState('monthly');
  
  const handleGetStarted = () => {
    navigate('/enquiry');
  };

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white py-16 px-4 min-h-screen">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
  <h1 className="text-5xl font-extrabold text-gray-900 tracking-tight mb-2">
    Create your own pricing
  </h1>
  <h2 className="text-3xl font-semibold text-gray-700 mb-4">
    Decide whats best for you
  </h2>
  <p className="text-xl text-indigo-600 font-medium max-w-3xl mx-auto">
    "Join Our Pilot Program Today – Unlock Exclusive Low Pricing!"
  </p>
</div>

        {/* Billing Toggle */}
        <div className="flex justify-center mb-12">
          <div className="bg-gray-100 p-1 rounded-xl inline-flex items-center">
            <button 
              onClick={() => setBillingPeriod('monthly')}
              className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
                billingPeriod === 'monthly' 
                  ? 'bg-white text-indigo-600 shadow-md' 
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Monthly
            </button>
            <button 
              onClick={() => setBillingPeriod('yearly')}
              className={`px-6 py-2 rounded-lg text-sm font-medium transition-all ${
                billingPeriod === 'yearly' 
                  ? 'bg-white text-indigo-600 shadow-md' 
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              Yearly <span className="text-xs font-semibold text-green-500 ml-1">Save 20%</span>
            </button>
          </div>
        </div>

        {/* Pricing Cards */}
        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {/* Starter Plan */}
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100 group relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-indigo-50 rounded-full opacity-70 group-hover:scale-150 transition-all duration-700"></div>
            <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-purple-50 rounded-full opacity-70 group-hover:scale-150 transition-all duration-700"></div>
            
            <div className="bg-indigo-100 text-indigo-700 text-sm font-semibold px-4 py-1 rounded-full inline-block mb-4">Starter</div>
            <p className="text-5xl font-extrabold text-gray-900">
              ${billingPeriod === 'monthly' ? '29' : '279'}
              <span className="text-lg font-normal text-gray-600">/{billingPeriod === 'monthly' ? 'month' : 'year'}</span>
            </p>
            <p className="text-gray-600 mt-2 mb-8 text-lg">Perfect for small teams getting started</p>
            
            <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-8"></div>
            
            <ul className="space-y-4 text-gray-700 text-base mb-8">
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-indigo-500 mr-3 mt-0.5 shrink-0" />
                <span>5 Agents</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-indigo-500 mr-3 mt-0.5 shrink-0" />
                <span>500 Responses/month</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-indigo-500 mr-3 mt-0.5 shrink-0" />
                <span>Basic Chat Widget</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-indigo-500 mr-3 mt-0.5 shrink-0" />
                <span>Email Support</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-indigo-500 mr-3 mt-0.5 shrink-0" />
                <span>Multi-lingual Support</span>
              </li>
            </ul>
            
            <div className="mb-8">
              <p className="text-sm text-gray-600 mb-2 font-medium">Social Profiles</p>
              <div className="flex space-x-2">
                <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
                  <FaTwitter className="w-4 h-4 text-indigo-500" />
                </div>
                <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
                  <FaFacebook className="w-4 h-4 text-indigo-500" />
                </div>
                <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center">
                  <FaInstagram className="w-4 h-4 text-indigo-500" />
                </div>
              </div>
            </div>
            
            <button 
              onClick={handleGetStarted}
              className="w-full bg-white text-indigo-600 border border-indigo-600 py-3 rounded-xl hover:bg-indigo-50 transition-colors font-semibold text-lg relative group overflow-hidden"
            >
              <span className="relative z-10">Get Started</span>
              <span className="absolute inset-0 bg-indigo-600 scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300"></span>
              <span className="absolute inset-0 flex items-center justify-center text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">Get Started</span>
            </button>
          </div>

          {/* Professional Plan */}
          <div className="bg-gradient-to-br from-indigo-600 to-purple-600 rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform scale-105 relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full"></div>
            <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-white/10 rounded-full"></div>
            
            <div className="bg-white/20 text-white text-sm font-semibold px-4 py-1 rounded-full inline-block mb-2 backdrop-blur-sm">Professional</div>
            <span className="absolute top-6 right-6 bg-white/20 text-white text-xs font-medium px-3 py-1 rounded-full backdrop-blur-sm">Most Popular</span>
            
            <p className="text-5xl font-extrabold text-white">
              ${billingPeriod === 'monthly' ? '99' : '948'}
              <span className="text-lg font-normal text-white/70">/{billingPeriod === 'monthly' ? 'month' : 'year'}</span>
            </p>
            <p className="text-white/90 mt-2 mb-8 text-lg">Ideal for growing businesses</p>
            
            <div className="h-px bg-gradient-to-r from-transparent via-white/30 to-transparent mb-8"></div>
            
            <ul className="space-y-4 text-white/90 text-base mb-8">
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-white mr-3 mt-0.5 shrink-0" />
                <span>10 Agents</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-white mr-3 mt-0.5 shrink-0" />
                <span>2,000 Responses/month</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-white mr-3 mt-0.5 shrink-0" />
                <span>Customizable Chat Widget</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-white mr-3 mt-0.5 shrink-0" />
                <span>3 Social Handles</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-white mr-3 mt-0.5 shrink-0" />
                <span>Analytics Dashboard</span>
              </li>
            </ul>
            
            <div className="mb-8">
              <p className="text-sm text-white/80 mb-2 font-medium">Social Profiles</p>
              <div className="flex space-x-2">
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                  <FaTwitter className="w-4 h-4 text-white" />
                </div>
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                  <FaFacebook className="w-4 h-4 text-white" />
                </div>
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center">
                  <FaInstagram className="w-4 h-4 text-white" />
                </div>
              </div>
            </div>
            
            <button 
              onClick={handleGetStarted}
              className="w-full bg-white text-indigo-600 py-3 rounded-xl hover:bg-indigo-50 transition-colors font-semibold text-lg shadow-lg"
            >
              Get Started
            </button>
          </div>

          {/* Enterprise Plan */}
          <div className="bg-white rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100 group relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-gray-50 rounded-full opacity-70 group-hover:scale-150 transition-all duration-700"></div>
            <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-gray-50 rounded-full opacity-70 group-hover:scale-150 transition-all duration-700"></div>
            
            <div className="bg-gray-800 text-white text-sm font-semibold px-4 py-1 rounded-full inline-block mb-4">Enterprise</div>
            <p className="text-5xl font-extrabold text-gray-900">Custom</p>
            <p className="text-gray-600 mt-2 mb-8 text-lg">For large-scale operations</p>
            
            <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent mb-8"></div>
            
            <ul className="space-y-4 text-gray-700 text-base mb-8">
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-gray-800 mr-3 mt-0.5 shrink-0" />
                <span>Unlimited Agents</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-gray-800 mr-3 mt-0.5 shrink-0" />
                <span>Custom Response Volume</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-gray-800 mr-3 mt-0.5 shrink-0" />
                <span>All Integrations</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-gray-800 mr-3 mt-0.5 shrink-0" />
                <span>API Access</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="w-5 h-5 text-gray-800 mr-3 mt-0.5 shrink-0" />
                <span>Dedicated Support</span>
              </li>
            </ul>
            
            <div className="mb-8">
              <p className="text-sm text-gray-600 mb-2 font-medium">Social Profiles</p>
              <div className="flex space-x-2">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                  <FaTwitter className="w-4 h-4 text-gray-700" />
                </div>
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                  <FaFacebook className="w-4 h-4 text-gray-700" />
                </div>
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                  <FaInstagram className="w-4 h-4 text-gray-700" />
                </div>
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center">
                  <FaLinkedin className="w-4 h-4 text-gray-700" />
                </div>
              </div>
            </div>
            
            <button 
              onClick={handleGetStarted}
              className="w-full bg-gray-800 text-white py-3 rounded-xl hover:bg-gray-900 transition-colors font-semibold text-lg shadow-md"
            >
              Contact Sales
            </button>
          </div>
        </div>

        {/* Add-ons Section */}
        <div className="mb-16">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Add-Ons</h2>
            <p className="text-xl text-indigo-600 font-medium max-w-3xl mx-auto">
              "Need more responses or channels? Scale your plan effortlessly with add-ons starting at just $0.05 per response or $10/channel."
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Additional Responses */}
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900">Additional Responses</h3>
                <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"></path>
                  </svg>
                </div>
              </div>
              <ul className="space-y-3">
                <li className="flex items-center justify-between pb-3 border-b border-gray-100">
                  <span className="text-gray-700">Starter Plan</span>
                  <span className="font-semibold text-indigo-600">$0.05 per response above 2,000</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="text-gray-700">Professional Plan</span>
                  <span className="font-semibold text-indigo-600">$0.04 per response above 5,000</span>
                </li>
              </ul>
            </div>
            
            {/* Additional Channels */}
            <div className="bg-white p-8 rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-shadow">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-xl font-bold text-gray-900">Additional Channels</h3>
                <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center">
                  <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0"></path>
                  </svg>
                </div>
              </div>
              <ul className="space-y-3">
                <li className="flex items-center justify-between pb-3 border-b border-gray-100">
                  <span className="text-gray-700">Starter Plan</span>
                  <span className="font-semibold text-purple-600">$10/channel beyond the included 3</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="text-gray-700">Professional Plan</span>
                  <span className="font-semibold text-purple-600">$15/channel beyond the included 5</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* FAQs */}
        <div className="max-w-4xl mx-auto mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Frequently Asked Questions</h2>
          
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Can I change my plan later?</h3>
              <p className="text-gray-600">Yes, you can upgrade or downgrade your plan at any time. Changes take effect at the beginning of the next billing cycle.</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">What happens if I exceed my response limit?</h3>
              <p className="text-gray-600">If you exceed your monthly response limit, additional responses are billed at the add-on rate for your plan. You'll be notified when you reach 80% of your limit.</p>
            </div>
            
            <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Do you offer custom solutions?</h3>
              <p className="text-gray-600">Absolutely! Our Enterprise plan is fully customizable to your specific needs. Contact our sales team to discuss your requirements.</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="relative overflow-hidden rounded-3xl">
          <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 to-purple-700"></div>
          <div className="absolute inset-0 opacity-20">
            <div className="absolute -left-20 -top-20 w-80 h-80 bg-white/20 rounded-full blur-3xl"></div>
            <div className="absolute right-0 bottom-0 w-96 h-96 bg-purple-400/20 rounded-full blur-3xl"></div>
            <div className="absolute left-1/2 top-0 w-64 h-64 bg-indigo-400/20 rounded-full blur-3xl"></div>
          </div>
          
          <div className="relative px-6 lg:px-12 py-20">
            <div className="grid md:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
              <div className="text-left">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">Ready to Transform Your Business?</h2>
                <p className="text-xl text-indigo-100 mb-8 max-w-md">Start using our AI agents today and experience the difference. Boost productivity, reduce costs, and stay ahead of the competition.</p>
                <button 
                  onClick={handleGetStarted}
                  className="bg-white text-indigo-600 px-10 py-4 rounded-xl font-semibold text-lg hover:bg-indigo-50 transition-all duration-300 inline-flex items-center shadow-lg hover:shadow-xl group"
                >
                  Get Started Now <FaArrowRight className="ml-3 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
              <div className="relative">
                <div className="absolute inset-0 bg-indigo-700/30 rounded-2xl backdrop-blur-sm transform rotate-6"></div>
                <div className="absolute inset-0 bg-purple-700/20 rounded-2xl backdrop-blur-sm transform -rotate-3"></div>
                <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-8 relative z-10">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-3 h-3 bg-red-500 rounded-full"></div>
                    <div className="w-3 h-3 bg-yellow-500 rounded-full"></div>
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                  </div>
                  <div className="space-y-3">
                    <div className="h-4 bg-white/20 rounded-full w-full"></div>
                    <div className="h-4 bg-white/20 rounded-full w-4/5"></div>
                    <div className="h-4 bg-white/20 rounded-full w-2/3"></div>
                    <div className="h-4 bg-white/20 rounded-full w-1/2"></div>
                    <div className="h-20 bg-indigo-500/30 rounded-xl w-full mt-6 border border-indigo-400/30"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;